import {ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { GenericModalService } from '../../../../services/generic-modal.service';
import {BusinessProcessVersion} from '../../../../Models/businessProcessVersion';
import {WfTableComponent} from '../../../../common/table-sort/wf-table.component';
import {EnumTranslator} from '../../../../Models/enum/enumTranslator';
import {FieldType} from '../../../../Models/enum/fieldType';
import {take} from 'rxjs/operators';
import {FieldsMultipleEditionComponent} from './fields-multiple-edition/fields-multiple-edition.component';
import {EditFieldsService} from '../../../../services/edit-fields.service';
import {FieldDetailComponent} from '../field-detail/field-detail.component';
import {FieldEditType} from '../../../../Models/enum/fieldEditType';

@Component({
  selector: 'app-fields-management',
  templateUrl: './fields-management.component.html',
  styleUrls: ['./fields-management.component.css']
})
export class FieldsManagementComponent implements OnInit {

  @ViewChild('dataTableFields', { static: false }) dataTableFields: WfTableComponent;

  bpId: number;
  inscription: Subscription;
  bpInfo: BusinessProcessVersion;
  fields: any[];
  currentUserId = parseInt(localStorage.getItem('userId'));
  fieldsSelection = false;
  filterText: string;
  pleaseWait: boolean;
  blockFieldsError: string;
  saveFieldsError: string;
  saveFieldsSucess: boolean;
  selectAllFields: boolean;
  availableStates;

  dateExibitionFormats: any[];
  fieldValidators: any[];
  fieldTextMasks:any[];
  fieldFloatingMasks:any[];


  constructor(
    private formBuilder: FormBuilder,
    private bpService: BusinessProcessService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: GenericModalService,
    private cdRef: ChangeDetectorRef,
    private editFieldsService: EditFieldsService
  ) { }

  ngOnInit() {
    this.inscription = this.route.params.subscribe(params => {
      this.bpId = params['businessProcessId'];
      this.getBusinessProcess();
      this.getFields();
      this.getAvailableStates();
      this.getEnumArray();
    });
  }

  getEnumArray() {
    let arrays = this.editFieldsService.getEnumArrays();
    this.dateExibitionFormats = arrays.dateExibitionFormat;
    this.fieldValidators = arrays.fieldValidator;
    this.fieldTextMasks = this.editFieldsService.getTextEnumMaskType();
    this.fieldTextMasks[0].label = "";
    this.fieldFloatingMasks = this.editFieldsService.getFloatingEnumMaskType();
    this.fieldFloatingMasks[0].label = "";
  }

  getBusinessProcess(){
    this.blockFieldsError = '';
    this.bpService.getLightBusinessProcess(this.bpId).subscribe(result => {
      if (result) {
        this.bpInfo = result;
      }
    }, error1 => this.blockFieldsError = error1);
  }

  getAvailableStates(){
    this.blockFieldsError = '';
    this.bpService.getStatesByBusinessProcessId(this.bpId).subscribe(result => {
      if (result){
        this.availableStates = result.map(m => ({ id: m.stateId, label: m.name }));
      }
    }, error1 => this.blockFieldsError = error1);
  }

  getFields(){
    this.blockFieldsError = '';
    this.pleaseWait = true;
    this.bpService.getFieldsByBusinessProcessId(this.bpId).subscribe(result => {
      this.pleaseWait = false;
      if (result){
        this.fields = result.fields;
        this.fields.forEach(field => {
          field.validatorDescription = this.getItemValue(field.validator, this.fieldValidators);
          field.selected = false;
          field.dirty = false;
          field.remove = false;
          field.extensionData = null;
        });
      }
    }, error1 => this.blockFieldsError = error1);
  }

  getFieldTypeEnumTranslated(fieldType) {
    if (!fieldType) return "";
    return EnumTranslator.getEnumValueTranslated(FieldType[fieldType]);
  }

  getItemValue(key, list) {
    if (key == null) return "";
    for (let x = 0; x < list.length; x ++)
    {
      if (list[x].key == key)
      {
        return list[x].label;
      }
    }
    return undefined;
  };

  changeFieldsSelection() {
    this.saveFieldsSucess = false;
    let count = 0;
    let filteredFields = this.filterData();
    filteredFields.forEach(field => {
      if (!field.blockingUserId || field.blockingUserId == this.currentUserId){
        field.selected = !this.fieldsSelection;
        count++;
      }
    });
    this.fieldsSelection = !this.fieldsSelection;
  }

  filterData() {
    const emptyFilter = (this.fields && this.fields.length === 0) || !this.filterText || this.filterText.trim() === '';
    if (emptyFilter) {
      return this.fields;
    }

    if (!emptyFilter) {
      return this.fields.filter((v) => {
        return (v.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0);
      });
    }
  }

  countSelectedFields() {
    return this.getLocalFields(CriteriaLocalField.Selected).length;
  }

  countDirtyOrRemovedFields() {
    return this.getLocalFields(CriteriaLocalField.DirtyOrRemoved).length;
  }

  hasSelectedAndRemovedItems() {
    const selected = this.getLocalFields(CriteriaLocalField.Selected);
    const removed = this.getLocalFields(CriteriaLocalField.Removed);
    return (selected.filter(
      field => {
        return removed.some( f2 => f2.elementId === field.elementId);
      }
    )).length > 0;
  }

  countAvailableFields(){
    let filteredFields = this.filterData();
    let list = filteredFields.filter((f) => !f.blockingUserId || f.blockingUserId == this.currentUserId);
    return list.length;
  }

  getLocalFields(criteria: CriteriaLocalField, completeField: boolean = false){
    if (!this.fields) return [];
    return this.fields.filter((v) => {
      switch (criteria){
        case CriteriaLocalField.Selected:
          return (v.selected);
        case CriteriaLocalField.SelectedAndNotNew:
          return (v.selected && v.fieldId != 0);
        case CriteriaLocalField.Dirty:
          return (v.dirty);
        case CriteriaLocalField.Removed:
          return (v.remove);
          case CriteriaLocalField.SelectedAndRemoved:
          return (v.remove && v.selected);
        case CriteriaLocalField.DirtyOrRemoved:
          return (v.dirty || v.remove);
        case CriteriaLocalField.CurrentUser:
          return (v.blockingUserId === this.currentUserId);
      }
    }).map(function(f){
      if (completeField){
        return f;
      }else{
        return {
          elementId : f.fieldId,
          elementName : f.name
        }
      }
    });
  }

  onSelectFieldChange() {
    this.saveFieldsSucess = false;
    if (this.countSelectedFields() < this.countAvailableFields()){
      this.selectAllFields = false;
      this.fieldsSelection = false;
    }
  }

  flagForRemoval() {
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão', 'Confirma a marcação para exclusão do(s) campo(s)?');
    alert.then((result) => {
      if (result.value) {
        this.blockFieldsError = '';
        this.beginEditing(
          ()=>{
            this.fields.forEach(field => {
              if (field.selected){
                field.remove = true;
                field.dirty = false;
                field.blockingUserId = this.currentUserId;
              }
            });
        })
      }
    });
  };

  cancelRemove() {
    let list = this.getLocalFields(CriteriaLocalField.SelectedAndRemoved);
    if (list.length == 0) return;
    this.cancelEditing(list, () => {
      this.fields.forEach(field => {
        if (field.remove && field.selected) {
          field.remove = false;
          field.blockingUserId = null;
        }
      });
    }, false);

  }

  beginEditing(successCallback){
    this.blockFieldsError = "";
    let list = this.getLocalFields(CriteriaLocalField.SelectedAndNotNew);

    if (list.length  == 0) {
      successCallback();
      return;
    }
    this.bpService.beginEditingGroup(3, list).subscribe(result => {
        successCallback();
      },
      error => {
        //mostra a msg de erro e recarrega todos os campos, pois não sabemos quais foram desbloqueados e quais não foram
        this.blockFieldsError = error;
        this.updateBlockingUserIdAttribute();
      });
  }

  cancelEditing(fields: any[], successCallback, callbackAnyway: boolean){
    this.blockFieldsError = "";
    if (fields.length  == 0 || !successCallback) return;
    this.blockFieldsError = '';
    this.bpService.cancelEditingGroup(3, fields).subscribe(result => {
        successCallback(this);
      },
      error => {
        if (callbackAnyway) {
          successCallback(this);
        }
        //mostra a msg de erro e recarrega todos os campos, pois não sabemos quais foram desbloqueados e quais não foram
        this.blockFieldsError = error;
        //this.updateBlockingUserIdAttribute();
      });
  }

  updateBlockingUserIdAttribute(){
    //this.blockFieldsError = '';
    this.bpService.getFieldsByBusinessProcessId(this.bpId).subscribe(result => {
      if (result){
        let newFieldList = result.fields;
        this.fields.forEach(field => {
          let dbField = newFieldList.filter((f) => {
            return (f.fieldId === field.fieldId);
          });
          if (dbField && dbField.length === 1){
            field.blockingUserId = dbField[0].blockingUserId;
            if (field.blockingUserId != null && field.blockingUserId != this.currentUserId) {
              field.selected = false;
            }
          }
        });
      }
    }, error1 => this.blockFieldsError = this.blockFieldsError + ' ' + error1);
  }

  newField() {
    this.blockFieldsError = '';
    this.bpService.checkRights(128)
      .subscribe( rights => {
        if (rights.length > 0) {
          const field = {fieldId: 0, isNew: true};
          this.openEditModal('Cadastrar', field);
        } else {
          this.blockFieldsError = 'Erro: Usuário não tem direito de efetuar esta ação.';
        }
      }, error1 => {
        this.blockFieldsError = error1;
      });
  }

  editFields() {
    if (this.countSelectedFields() == 1){
      this.beginEditing(()=> {
        let selectedField = this.getLocalFields(CriteriaLocalField.Selected, true)[0];
        selectedField.blockingUserId = this.currentUserId;
        selectedField.isNew = false;
        this.openEditModal('Editar', selectedField);
      })
    } else if (this.countSelectedFields() > 1){
      this.beginEditing(() => {
        this.fields.forEach(field => {
          if (field.selected){
            field.blockingUserId = this.currentUserId;
          }
        });
        let inputDataModal = {
          countSelectedFields: this.countSelectedFields(),
          availableStates: this.availableStates
        };
        const destComponent: any = FieldsMultipleEditionComponent;
        const result$ = this.modalService.showObjModal(destComponent, `Editar Campos`, inputDataModal, 'modal-lg');

        if (result$) {
          result$.asObservable()
            .pipe(take(1))
            .subscribe(result => {
              if (result) {
                this.applyChangesToSelectedFields(result);
              }
            });
        }
      });
    }
  }

  openEditModal(viewType, field){
    let inputDataModal = {
      fieldId: field.fieldId,
      fieldToEdit: field,
      editType: FieldEditType.multiple,
      availableStates: this.availableStates,
      availableFields: this.fields
    };

    const destComponent: any = FieldDetailComponent;
    const result$ = this.modalService.showObjModal(destComponent, `${viewType} Campo`, inputDataModal, 'modal-xl');
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe(result => {
          if (!result) return;
          result.dirty = true;
          if (result.isNew) {
            result.blockingUserId = this.currentUserId;
            result.selected = false;
            this.fields.push(result);
          } else {
            this.applyChangesToSelectedField(result);
          }
        });
    }
  }

  applyChangesToSelectedFields(fieldChanges){
    let fields = this.getLocalFields(CriteriaLocalField.Selected, true);
    fields.forEach(f => {
      f.dirty = true;
      if (fieldChanges.chkDisplayName){
        f.displayName = fieldChanges.displayName.trim();
      }
      if (fieldChanges.chkDescription){
        f.description = fieldChanges.description.trim();
      }
      if (fieldChanges.chkType){
        f.type = fieldChanges.type;
        f.length = fieldChanges.length;
        f.dateExibitionFormat = fieldChanges.dateExibitionFormat;
        f.maskType = fieldChanges.maskType;
        if (fieldChanges.type === 5) {
          f.validator = 0;
        }
      }
      if (fieldChanges.chkRequired){
        f.isRequired = fieldChanges.isRequired;
      }
      if (fieldChanges.chkTrackable){
        f.isTrackable = fieldChanges.isTrackable;
      }
      if (fieldChanges.chkValidator){
        f.validator = fieldChanges.validator;
      }
      if (fieldChanges.chkStates){
        f.stateIdsInWhichIsEditable = fieldChanges.stateIdsInWhichIsEditable;
      }

    })
  }

  applyChangesToSelectedField(fieldChanges){
    let fields = this.getLocalFields(CriteriaLocalField.Selected, true);
    this.fields.forEach(f => {
      if (f.fieldId === fieldChanges.fieldId){
        f.dirty = true;
        f.name = fieldChanges.name;
        f.displayName = fieldChanges.displayName.trim();
        f.description = fieldChanges.description.trim();
        f.type = fieldChanges.type;
        f.length = fieldChanges.length;
        f.dateExibitionFormat = fieldChanges.dateExibitionFormat;
        f.maskType = fieldChanges.maskType;
        f.isRequired = fieldChanges.isRequired;
        f.isTrackable = fieldChanges.isTrackable;
        f.validator = fieldChanges.validator;
        f.stateIdsInWhichIsEditable = fieldChanges.stateIdsInWhichIsEditable;
        return;
      }
    })
  }

  onSave() {
    let alert = this.modalService.showConfirmModal('Confirmação para salvar', 'Tem certeza que deseja salvar todas as alterações? Essa operação não é reversível.');
    alert.then((result) => {
      if (result.value) {
        this.saveFieldsError = '';
        this.blockFieldsError = '';
        this.saveFieldsSucess = false;

        let dirtyFields = this.getLocalFields(CriteriaLocalField.Dirty, true);
        let removedFields = this.getLocalFields(CriteriaLocalField.Removed, true);

        if (dirtyFields.length == 0 && removedFields.length == 0) return;

        this.bpService.saveFields(this.bpId, dirtyFields, removedFields).subscribe(result => {
            this.getFields();
            this.saveFieldsSucess = true;
            setTimeout(() => { this.saveFieldsSucess = false;}, 2500);
          },
          error => {
            this.saveFieldsError = error;
          });
      }
    });
  }

  onBack() {
    let alert: any;
    if (this.getLocalFields(CriteriaLocalField.DirtyOrRemoved).length == 0){
      this.navigateToBusinessProcessPage(this);
      return;
    }

    alert = this.modalService.showConfirmModal('Há alterações não salvas', 'Deseja descartar as alterações e voltar para edição de processo de negócio?');
    alert.then((result) => {
      if (result.value) {
        //iremos desbloquear todos os campos antes de voltar para a tela anterior
        let list = this.getLocalFields(CriteriaLocalField.CurrentUser);
        this.cancelEditing(list, this.navigateToBusinessProcessPage, true);
      }
    });
  }

  navigateToBusinessProcessPage(context){
    context.router.navigate(['/businessProcess', context.bpId, 1]);
  }




}
enum CriteriaLocalField {
  Selected,
  Dirty,
  Removed,
  CurrentUser,
  DirtyOrRemoved,
  SelectedAndRemoved,
  SelectedAndNotNew
}
